@if (!data.disableDialogClose) {
<div class="close_container">
    <button
        mat-icon-button
        class="confirm-dialog-close-button"
        [mat-dialog-close]="CancelResult"
    >
        <mat-icon>close</mat-icon>
    </button>
</div>
}

<h2
    class="m-l--6 {{ data.className }}"
    mat-dialog-title
>
    {{ data.title }}
</h2>

<mat-dialog-content class="mat-typography">
    <p [innerHTML]="data.description | purify : ['a', 'b'] : ['target']"></p>
    @if (data.optional_description) {
    <p [innerHTML]="data.optional_description | purify : ['a', 'b'] : ['target']"><br /></p>
    } @if (data.hasNote) {
    <div class="full-height p-v-10">
        <mat-form-field
            appearance="outline"
            class="textarea-container"
            [floatLabel]="'always'"
        >
            <mat-label>Notes</mat-label>
            <textarea
                #textarea
                matInput
                class="textarea-small hidden-overflow"
                [placeholder]="textarea.value ? textarea.value : ''"
                [(ngModel)]="textarea.value"
                (ngModelChange)="setNote(textarea.value)"
                [ngModelOptions]="{ standalone: true }"
                cdkTextareaAutosize
                cdkAutosizeMinRows="3"
                [maxlength]="2000"
            ></textarea>
        </mat-form-field>
        <div class="char-count">{{ getTypedChars(textarea.value) }}/2000</div>
    </div>
    }
</mat-dialog-content>

<mat-dialog-actions
    [ngClass]="{ 'flex-row': !data.stackButtonsVertically, 'flex-column-reverse': data.stackButtonsVertically }"
    class="flex-start-start flex-gap-16 justify-space-between"
>
    <div>
        <div
            *appShowSpinner="isLoading && hasChosenPrimary"
            id="primary-button-confirm-dialog"
        >
            @switch (data.primaryButton.type) { @case ('secondary') {
            <button
                mat-stroked-button
                [disabled]="isLoading"
                (click)="action(data.primaryButton)"
            >
                {{ data.primaryButton.text }}
            </button>
            } @case ('negative') {
            <button
                mat-stroked-button
                color="warn"
                [disabled]="isLoading"
                (click)="action(data.primaryButton)"
            >
                {{ data.primaryButton.text }}
            </button>
            } @default {
            <button
                mat-flat-button
                color="primary"
                [disabled]="isLoading"
                (click)="action(data.primaryButton)"
            >
                {{ data.primaryButton.text }}
            </button>
            } }
        </div>
    </div>

    @if (data.secondaryButton) {
    <div>
        <div
            id="secondary-button-confirm-dialog"
            *appShowSpinner="isLoading && !hasChosenPrimary"
        >
            @switch (data.secondaryButton.type) { @case ('primary') {
            <button
                mat-flat-button
                color="primary"
                [disabled]="isLoading"
                (click)="action(data.secondaryButton)"
            >
                {{ data.secondaryButton.text }}
            </button>
            } @case ('negative') {
            <button
                mat-stroked-button
                color="warn"
                [disabled]="isLoading"
                (click)="action(data.secondaryButton)"
            >
                {{ data.secondaryButton.text }}
            </button>
            } @default {
            <button
                mat-stroked-button
                [disabled]="isLoading"
                (click)="action(data.secondaryButton)"
            >
                {{ data.secondaryButton.text }}
            </button>
            } }
        </div>
    </div>
    } @if (data.cancelButton) {
    <button
        id="cancel-button-confirm-dialog"
        mat-stroked-button
        [disabled]="isLoading"
        [mat-dialog-close]="CancelResult"
    >
        {{ data.cancelButton.text }}
    </button>
    }
</mat-dialog-actions>
